export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';
export const SHIPPING_THRESHOLD = 100;
export const SHIPPING_FEE = 7;
